import {
  CLIMATE_TYPES,
  RoomTemperatureResponse,
} from '@models/temperature.types';
import {
  WaterUsageAPIResponse,
  WaterUsageUnit,
} from '@models/waterUsage.types';

import { API_BASE_URL } from './api.constants';
import { generateApiUrl } from './api.utils';
import { authClient } from './client.api';

const MEASUREMENT_API_BASE_URL = `${API_BASE_URL}apartments` as const;

export const MEASUREMENT_API_URLS = {
  CLIMATE: `${MEASUREMENT_API_BASE_URL}/:apartmentId/measurements`,
  WATER_USAGE: `${MEASUREMENT_API_BASE_URL}/waterconsumption/listdaily/:apartmentId`,
  WATER_USAGE_RANGE: `${MEASUREMENT_API_BASE_URL}/waterconsumption/hasdata/:apartmentId`,
} as const;

export const measurementsApi = {
  getClimate: ({
    apartmentId,
    ...payload
  }: {
    apartmentId: string;
    startDateTime: number;
    measurementType: CLIMATE_TYPES;
  }) =>
    authClient.get<RoomTemperatureResponse>(
      generateApiUrl(MEASUREMENT_API_URLS.CLIMATE, { apartmentId }),
      { params: payload }
    ),

  getWaterUsage: ({
    apartmentId,
    ...payload
  }: {
    apartmentId: string;
    year: string;
    month: string;
    unit: WaterUsageUnit;
  }) =>
    authClient.get<WaterUsageAPIResponse>(
      generateApiUrl(MEASUREMENT_API_URLS.WATER_USAGE, { apartmentId }),
      { params: payload }
    ),

  getWaterUsageRange: (apartmentId: string) =>
    authClient.get<Pick<WaterUsageAPIResponse, 'period'>>(
      generateApiUrl(MEASUREMENT_API_URLS.WATER_USAGE_RANGE, { apartmentId }),
      {
        validateStatus: (status) => status === 200 || status === 404, // Do not throw for 404
      }
    ),
};
